import httpHubless from 'hub-http/clients/noPortalApiClient';
const API_BASE = 'security-phone-numbers/v1';
export function getConfiguration() {
  return httpHubless.get(`${API_BASE}/setup`);
}
export function configure(phoneNumber) {
  return httpHubless.post(`${API_BASE}/setup/configure`, {
    data: {
      phoneNumber
    }
  });
}
export function resendCode(phoneNumber) {
  return httpHubless.put(`${API_BASE}/setup/resend-code`, {
    data: {
      phoneNumber
    }
  });
}
export function confirm(codeAttempt) {
  return httpHubless.put(`${API_BASE}/setup/confirm`, {
    data: {
      codeAttempt
    }
  });
}